export const ExcludeBasicFareBrandId = 'BE';
export const ExcludeBasicMainBrandId = 'BMAIN';
export const BffGeolocationErrortext = 'No Airport Found';
